module.exports = __webpack_public_path__ + "img/element-icons-logo-wavve-only.a1683da1.svg";